import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["skeleton", "frame"]

  hideSkeleton() {
    if (this.hasSkeletonTarget) {
      this.skeletonTarget.style.display = "none"
    }
  }
}
